/* Llama Land opt-in popup (hybrid). Rendered by snippets/ll-popup.liquid only when settings.ll_popup_enabled is on.
   Our code: art, tag, Apron Earnest, close, teaser, triggers. Klaviyo EMBED form (inside our dialog): fields, lists,
   SMS consent text, click-to-text, one-time code. We follow Klaviyo's `klaviyoForms` window events to move the art.
   The dialog (with this device's <div class="klaviyo-form-ID">) is server-rendered, closed, by the snippet: Klaviyo does
   not render embed divs added after load (popups/llama-land/BUILD-NOTES-research.md 1c).
   Fails closed: no form id for this device, Klaviyo not on the page, or the embed never renders = no popup, no teaser.
   Storage (all try/catch): localStorage llp:hide (dismissed, 5 days), llp:done (finished the form);
   sessionStorage llp:pv (page views), llp:entry (google|other), llp:shown (auto-open used), llp:teaser (on|off).
   QA only: ?llp=open opens now, ?llp=teaser shows the teaser, ?llp=reset clears the keys above.
   Aliases for Brad: ?ll_popup=now | teaser | reset, and ?ll_popup=auto (reset + run the real triggers).
   PREVIEW STAND-IN (unpublished themes, no Klaviyo form id for this device): the snippet's <template id="llp-tpl-standin">
   draws the approved Round 2 steps. It sends nothing (no fetch, no Klaviyo, no sms: link). Klaviyo's "already identified"
   check is skipped there so a reviewer who is already a subscriber still sees it, and automated browsers (other sessions'
   QA on the draft) never get an auto-open unless the URL says ?ll_popup=auto. */
(function () {
  'use strict';
  if (window.__llPopup) return;
  window.__llPopup = true;

  /* ---- Klaviyo adapter: every Klaviyo-specific name lives here (verify against Klaviyo's docs before launch). ---- */
  var KLAVIYO = {
    /* 'embed' (default): Klaviyo embed inside our dialog. 'popup' (fallback B2): our trigger + teaser open the Klaviyo
       popup/full-page form (set to "Only on a custom trigger" in Klaviyo) and our dialog is not used. Theme setting. */
    modes: ['embed', 'popup'],
    openPopup: function (id) { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', id]); },
    event: 'klaviyoForms',                      // window CustomEvent; detail = { type, formId, metaData }
    readyTypes: ['embedOpen', 'open'],          // the embed has rendered
    advanceTypes: ['stepSubmit', 'submit'],     // a step was submitted; a 'submit' right after a 'stepSubmit' is the same step
    closeTypes: ['close'],
    redirectTypes: ['redirectedToUrl'],         // e.g. desktop "START SAVING"
    readyTimeoutMs: 8000,                       // no render by then = fail closed
    hostClass: function (id) { return 'klaviyo-form-' + id; },
    stepName: function (d) {
      var m = (d && d.metaData) || {};
      return String(m.$step_name || m.step_name || m.stepName || (d && d.stepName) || '').trim().toLowerCase();
    },
    /* Klaviyo documents no step name on stepSubmit, so we also read which fields came in (research 1a, inference:
       verify in the builder test). Returns the art step that comes next, or ''. */
    nextFromFields: function (d, dev) {
      var m = (d && d.metaData) || {}, has = function (re) { return Object.keys(m).some(function (k) { return re.test(k); }); };
      if (has(/opt_?in_?code|one.?time|otp|verification/i)) return 'success';
      if (has(/phone/i)) return dev === 'phone' ? 'success' : 'code';
      if (has(/email/i)) return 'sms';
      if (has(/shopping.?for/i)) return 'email';
      return '';
    },
    /* Step (view) names in the live forms R77rje / XfmD3p, mapped to the art step that comes NEXT. Unknown names fall
       back to the device's order below (one step per submit). */
    next: { 'quiz': 'email', 'email opt-in': 'sms', 'sms opt-in': { phone: 'success', desktop: 'code' }, 'one-time code': 'success' },
    order: { phone: ['quiz', 'email', 'sms', 'success'], desktop: ['quiz', 'email', 'sms', 'code', 'success'] },
    available: function () { return standin || !!(window._klOnsite || window.klaviyo || window._learnq); },
    /* Mirrors the live forms' "existing user" suppression. Resolves false if Klaviyo can't say within 1.5 s. */
    isIdentified: function () {
      return new Promise(function (res) {
        if (standin) return res(false);
        var k = window.klaviyo;
        if (!k || typeof k.isIdentified !== 'function') return res(false);
        var t = setTimeout(function () { res(false); }, 1500);
        try { Promise.resolve(k.isIdentified()).then(function (v) { clearTimeout(t); res(!!v); }, function () { clearTimeout(t); res(false); }); }
        catch (e) { clearTimeout(t); res(false); }
      });
    },
    /* Text inside the embed we restyle (words untouched). Both live consent texts contain this phrase. */
    consentRe: /data rates may apply/i,
    declineRe: /^\s*no thanks\b/i
  };

  var cfgEl = document.getElementById('llp-config');
  var wordsEl = document.getElementById('llp-words');
  if (!cfgEl || !wordsEl) return;
  var CFG, W;
  try { CFG = JSON.parse(cfgEl.textContent); W = JSON.parse(wordsEl.textContent); } catch (e) { return; }

  function dismissHiddenPreviewForms() {
    if (!document.documentElement.classList.contains('llp-preview') ||
        !window.Shopify || !Shopify.theme || Shopify.theme.role !== 'unpublished') return;
    var closing = new WeakSet();
    var queued = false;
    function dismiss() {
      queued = false;
      document.querySelectorAll('form[data-testid="klaviyo-form-R77rje"], form[data-testid="klaviyo-form-XfmD3p"]').forEach(function (form) {
        var modal = form.closest('[role="dialog"]');
        if (!modal) return;
        if (modal.getAttribute('data-kl-scroll-locking-modal') !== 'true') {
          closing.delete(modal);
          return;
        }
        if (!document.documentElement.classList.contains('llp-preview') || closing.has(modal)) return;
        var button = modal.querySelector('button.klaviyo-close-form');
        if (!button) return;
        closing.add(modal);
        button.click();
      });
    }
    var observer = new MutationObserver(function () {
      if (!queued) { queued = true; requestAnimationFrame(dismiss); }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-kl-scroll-locking-modal'] });
    dismiss();
  }
  dismissHiddenPreviewForms();

  /* ---- storage ---- */
  var P = 'llp:';
  function sGet(area, k) { try { return window[area].getItem(P + k); } catch (e) { return null; } }
  function sSet(area, k, v) { try { window[area].setItem(P + k, String(v)); } catch (e) { /* private mode: run without memory */ } }
  function sDel(area, k) { try { window[area].removeItem(P + k); } catch (e) { /* ignore */ } }
  var L = 'localStorage', S = 'sessionStorage';

  var qs; try { qs = new URLSearchParams(location.search); } catch (e) { qs = { get: function () { return null; } }; }
  var force = qs.get('llp');
  var llq = qs.get('ll_popup');
  if (!force && llq) force = { now: 'open', teaser: 'teaser', reset: 'reset', auto: 'reset' }[llq] || null;
  if (force === 'reset') { ['hide', 'done'].forEach(function (k) { sDel(L, k); }); ['pv', 'entry', 'shown', 'teaser'].forEach(function (k) { sDel(S, k); }); }

  var mm = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var dev = cfgEl.getAttribute('data-dev') || (mm('(max-width: 767px)') && mm('(pointer: coarse)') ? 'phone' : 'desktop');
  var mode = KLAVIYO.modes.indexOf(CFG.mode) > -1 ? CFG.mode : 'embed';
  var dialogEl = document.getElementById('llp-dialog');
  if (mode === 'embed' && !dialogEl) return;                  // snippet removed it: nothing can show on this page
  var formId = String((CFG.forms && CFG.forms[dev]) || '').trim();
  /* preview stand-in: the snippet set data-standin only on an unpublished theme with no form for this device */
  var standin = cfgEl.getAttribute('data-standin') === '1' && !!(window.Shopify && Shopify.theme && Shopify.theme.role !== 'main');
  if (standin) { mode = 'embed'; formId = 'standin'; }
  if (!/^[A-Za-z0-9]+$/.test(formId)) return;               // fail closed: no (valid) form id for this device

  /* ---- page rules ---- */
  var path = location.pathname.toLowerCase();
  var blocked = /(^|\/)(pages|cart|checkout|checkouts|account)(\/|$)/.test(path) ||
    /\/products\/kids-complete-wellness-bundle(\/|$)/.test(path) ||
    (dev === 'phone' && (CFG.kind === 'blog' || /(^|\/)blogs(\/|$)/.test(path) || /utm_popup=secretsale/i.test(location.search)));
  if (blocked && force !== 'open' && force !== 'teaser') return;
  if (CFG.designMode && !force) return;

  var pv = (parseInt(sGet(S, 'pv'), 10) || 0) + 1;
  sSet(S, 'pv', pv);
  if (pv === 1 || !sGet(S, 'entry')) {
    var ref = ''; try { ref = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch (e) { ref = ''; }
    sSet(S, 'entry', /(^|\.)google\.[a-z]{2,3}(\.[a-z]{2})?$/.test(ref) ? 'google' : 'other');
  }
  /* Phone, first page of a visit from Google search: the small teaser only (Google interstitial rule; legal memo). */
  var teaserOnly = dev === 'phone' && pv === 1 && sGet(S, 'entry') === 'google';
  /* Phone, page 2 or later of the visit: 10 s is enough, no scroll needed (legal memo "or the 2nd page view"). Setting. */
  var page2 = dev === 'phone' && CFG.page2 !== false && pv >= 2;

  var DAY = 864e5;
  var done = !!sGet(L, 'done');
  var hideAt = parseInt(sGet(L, 'hide'), 10) || 0;
  var dismissed = hideAt && (Date.now() - hideAt) < (CFG.hideDays || 5) * DAY;
  var autoOk = !done && !dismissed && !sGet(S, 'shown');
  var delayMs = Math.max(10, Number(CFG.delay) || 10) * 1000;   // never in the first 10 s
  var t0 = Date.now();

  /* ---- shared state ---- */
  var root = null, pop = null, host = null, teaser = null, ready = false, opening = false, isOpen = false;
  var step = 'quiz', lastAdvance = 0, lastFocus = null, cssPromise = null, mo = null;
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };

  function fillWords(el) {
    $$('[data-t]', el).forEach(function (n) { var v = W[n.getAttribute('data-t')]; if (v != null) n.textContent = v; });
    $$('[data-t-label]', el).forEach(function (n) { var v = W[n.getAttribute('data-t-label')]; if (v != null) n.setAttribute('aria-label', v); });
  }
  function loadCss() {
    if (cssPromise) return cssPromise;
    cssPromise = new Promise(function (res) {
      if (document.querySelector('link[data-llp-css]')) return res();
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = CFG.css; l.setAttribute('data-llp-css', '');
      var t = setTimeout(res, 3000);
      l.onload = l.onerror = function () { clearTimeout(t); res(); };
      document.head.appendChild(l);
    });
    return cssPromise;
  }

  /* ---- teaser ---- */
  function showTeaser() {
    if (teaser || done || (dismissed && force !== 'teaser') || sGet(S, 'teaser') === 'off' || !KLAVIYO.available()) return;
    if (mode === 'embed' && !ready && force !== 'teaser') return;   // fail closed: never tease a form that isn't there
    var tpl = document.getElementById('llp-tpl-teaser'); if (!tpl) return;
    loadCss().then(function () {
      if (teaser || isOpen || done || sGet(S, 'teaser') === 'off') return;
      previewBar();
      teaser = tpl.content.firstElementChild.cloneNode(true);
      teaser.classList.add('llp-tsr--' + dev);
      fillWords(teaser);
      $('[data-llp-open]', teaser).addEventListener('click', function () { openDialog('teaser'); });
      $('[data-llp-teaser-x]', teaser).addEventListener('click', function () { sSet(S, 'teaser', 'off'); removeTeaser(); });
      document.body.appendChild(teaser);
      sSet(S, 'teaser', 'on');
      watchBars();
    });
  }
  function removeTeaser() { if (teaser) { teaser.remove(); teaser = null; } }
  /* Below 1024px the teaser sits bottom-left, where the sticky add-to-cart bars slide in. Hide it while one is on screen
     (design-system §11: one floater beyond the header; okendo-frontend DESIGN.md §7). Same offer and click target. */
  var STICKY_BARS = '.pdpv2-sticky-bar, .sticky-atc-bar, .bts-sticky, .ll-rt-sticky, [data-ll-sticky-atc]';
  var barsWatched = false;
  function barOnScreen() {
    return $$(STICKY_BARS).some(function (b) {
      if (b.hidden || (teaser && teaser.contains(b))) return false;
      var r = b.getBoundingClientRect(), cs = getComputedStyle(b);
      return r.height > 0 && r.width > 0 && r.top < window.innerHeight - 1 && r.bottom > 0 &&
        cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0.05;
    });
  }
  /* 1024-1199: the left gutter is narrower than the 44px edge tab, so some cards, arrows and text run under it.
     Tuck the tab (hidden, same place) while anything with a box, media or text sits under its right edge. */
  var TUCK_MQ = '(min-width: 1024px) and (max-width: 1199.98px)';
  function tabOverlaps() {
    if (!teaser || !document.elementsFromPoint) return false;
    var r = teaser.getBoundingClientRect(), vw = window.innerWidth; if (!r.width) return false;   // the wrapper: no entrance transform
    for (var y = r.top + 4; y < r.bottom; y += 12) {
      var hits = document.elementsFromPoint(r.right - 2, y);
      for (var i = 0; i < hits.length; i++) {
        var e = hits[i]; if (teaser.contains(e) || e === document.body || e === document.documentElement) continue;
        var q = e.getBoundingClientRect(); if (q.width >= vw - 30 || q.width < 30 || q.left < -1) continue;
        var cs = getComputedStyle(e);
        if (cs.backgroundColor !== 'rgba(0, 0, 0, 0)' || parseFloat(cs.borderLeftWidth) > 0 || cs.boxShadow !== 'none' ||
            /^(IMG|VIDEO|PICTURE|SVG|CANVAS|BUTTON|A|INPUT|SELECT|TEXTAREA)$/i.test(e.tagName)) return true;
        for (var n = e.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && /\S/.test(n.nodeValue)) return true;
      }
    }
    return false;
  }
  function syncBars() {
    if (!teaser) return;
    teaser.classList.toggle('llp-tsr--under-bar', !mm('(min-width: 1024px)') && barOnScreen());
    teaser.classList.toggle('llp-tsr--tuck', mm(TUCK_MQ) && tabOverlaps());
  }
  function watchBars() {
    syncBars();
    setTimeout(syncBars, 500);   // again once the teaser's entrance animation (.42s) has settled, even without a scroll
    if (barsWatched) return;
    barsWatched = true;
    var q = false, late = 0;
    var check = function () {
      if (!q) { q = true; requestAnimationFrame(function () { q = false; syncBars(); }); }
      clearTimeout(late); late = setTimeout(syncBars, 450);   // bars slide in over ~300ms after the scroll that shows them
    };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    try {
      var bo = new MutationObserver(check);
      $$(STICKY_BARS).forEach(function (b) { bo.observe(b, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] }); });
    } catch (e) { /* scroll + resize still cover it */ }
  }

  /* ---- dialog ---- */
  // Form mechanics stay tied to the original device (desktop OTP vs phone tap-to-text).
  // The visual layout follows the viewport, including a resized desktop preview.
  function syncLayout() {
    if (!root) return;
    var phoneLayout = mm('(max-width: 767px)');
    root.classList.toggle('llp--phone', phoneLayout);
    root.classList.toggle('llp--desktop', !phoneLayout);
    var vb = phoneLayout ? '370 -400 700 960' : '470 -330 500 860';
    $$('.llp-world', root).forEach(function (s) {
      if (s.getAttribute('viewBox') !== vb) s.setAttribute('viewBox', vb);
    });
  }
  function build() {
    if (!dialogEl || !document.contains(dialogEl)) return false;
    root = dialogEl;
    syncLayout();
    window.addEventListener('resize', syncLayout);
    fillWords(root);
    pop = $('[data-llp-pop]', root);
    host = $('[data-llp-host]', root);
    if (!pop || !host) { failClosed(); return false; }
    // The shell owns dismissals, including the same cooldown as the close button.
    // Capture before the embedded form handles the click.
    host.addEventListener('click', function (e) {
      var control = e.target.closest && e.target.closest('button, a, [role="button"]');
      if (!control || !KLAVIYO.declineRe.test(control.textContent || '')) return;
      e.preventDefault();
      e.stopPropagation();
      close('decline');
    }, true);
    $('[data-llp-close]', root).addEventListener('click', function () { close('x'); });
    $('[data-llp-scrim]', root).addEventListener('click', function () { close('scrim'); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close('outside'); });
    if (root.parentElement !== document.body) document.body.appendChild(root);   // escape any stacking context
    if (standin) { buildStandin(); markReady(); return true; }
    var check = function () { decorate(); if (!ready && host.querySelector('form, input, button')) markReady(); };
    mo = new MutationObserver(check);
    mo.observe(host, { childList: true, subtree: true, characterData: true });
    check();                                            // Klaviyo may have drawn the embed before this script ran
    return true;
  }
  /* ---- preview stand-in: the approved steps, drawn by the theme, sending nothing ---- */
  function buildStandin() {
    var tpl = document.getElementById('llp-tpl-standin');
    if (!tpl || $('.llp-sd', host)) return;
    var SW = {}; try { SW = JSON.parse(document.getElementById('llp-standin-words').textContent); } catch (e) { SW = {}; }
    var t = {}, k;
    for (k in W) t[k] = W[k];
    [SW.shared || {}, SW[dev] || {}].forEach(function (o) { for (var j in o) t[j] = o[j]; });
    var sd = tpl.content.firstElementChild.cloneNode(true);
    $$('[data-only]', sd).forEach(function (n) { if (n.getAttribute('data-only') !== dev) n.remove(); });
    $$('[data-t]', sd).forEach(function (n) { var v = t[n.getAttribute('data-t')]; if (v == null || v === '') n.remove(); else n.textContent = v; });
    $$('[data-t-html]', sd).forEach(function (n) { n.innerHTML = t[n.getAttribute('data-t-html')] || ''; });   // verbatim consent (our own JSON)
    $$('[data-t-ph]', sd).forEach(function (n) { var v = t[n.getAttribute('data-t-ph')]; if (v) n.setAttribute('placeholder', v); });
    host.appendChild(sd);
    var rib = document.createElement('p');                 // internal marker, preview themes only (not a customer string)
    rib.className = 'llp-rib';
    rib.textContent = 'Preview stand-in · nothing is sent';
    root.appendChild(rib);
    var go = function (s) { setStep(s); };
    $$('.llp-choice', sd).forEach(function (b) {
      b.addEventListener('click', function () {
        b.setAttribute('aria-pressed', 'true');
        setTimeout(function () { b.removeAttribute('aria-pressed'); go('email'); }, 180);
      });
    });
    $$('[data-llp-decline]', sd).forEach(function (b) { b.addEventListener('click', function () { close('decline'); }); });
    var bad = function (inp, on) {
      inp.setAttribute('aria-invalid', on ? 'true' : 'false');
      var err = document.getElementById(inp.getAttribute('aria-describedby'));
      if (err) err.classList.toggle('is-on', on);
      if (on) inp.focus();
    };
    var f = function (name) { return $('[data-llp-f="' + name + '"]', sd); };
    f('email').addEventListener('submit', function (e) {
      e.preventDefault();
      var i = $('#llp-email', sd), ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value.trim());
      bad(i, !ok); if (ok) go('sms');
    });
    f('sms').addEventListener('submit', function (e) {
      e.preventDefault();
      if (dev === 'phone') { go('success'); return; }   // live: click-to-text opens Messages; the stand-in never does
      var i = $('#llp-tel', sd), ok = i.value.replace(/\D/g, '').length >= 10;
      bad(i, !ok); if (ok) go('code');
    });
    if (f('code')) f('code').addEventListener('submit', function (e) {
      e.preventDefault();
      var i = $('#llp-otp', sd), ok = /^\d{6}$/.test(i.value.trim());
      bad(i, !ok); if (ok) go('success');
    });
    $$('[data-llp-done]', sd).forEach(function (a) { a.addEventListener('click', function () { close('redirect'); }); });
  }

  var readyWaiters = [];
  function markReady() { if (ready) return; ready = true; readyWaiters.splice(0).forEach(function (f) { f(true); }); }
  function waitReady() {
    return new Promise(function (res) {
      if (ready) return res(true);
      readyWaiters.push(res);
      setTimeout(function () { res(ready); }, KLAVIYO.readyTimeoutMs);
    });
  }
  function failClosed() {
    if (mo) mo.disconnect();
    if (root) root.remove();
    root = pop = host = dialogEl = null;
    removeTeaser();
    sSet(S, 'shown', '1'); sSet(S, 'teaser', 'off');
    if (window.console) console.info('[ll-popup] Klaviyo form ' + formId + ' did not render; popup stays off.');
  }

  function openDialog(source) {
    if (isOpen || opening || done) return;
    if (!KLAVIYO.available() && force !== 'open') { failClosed(); return; }
    lastFocus = document.activeElement;
    if (mode === 'popup') {                             // fallback B2: Klaviyo draws its own popup
      removeTeaser(); KLAVIYO.openPopup(formId); signal('shown', source); return;
    }
    opening = true;
    loadCss().then(function () {
      if (!root && !build()) { opening = false; return; }
      return waitReady().then(function (ok) {
        opening = false;
        if (!ok) { failClosed(); return; }
        show(source);
      });
    });
  }
  /* our own "popup shown" signal: Klaviyo's view count is inflated because the embed renders at page load (research 1c) */
  function signal(type, source) {
    var detail = { type: type, device: dev, formId: formId, mode: mode, source: source || '' };
    try { window.dispatchEvent(new CustomEvent('llPopup', { detail: detail })); } catch (e) { /* old browsers */ }
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'll_popup_' + type, ll_popup: detail }); } catch (e) { /* ignore */ }
  }
  /* preview stand-in only: room for Shopify's preview bar at the bottom of the screen (never present on live) */
  function previewBar() {
    if (!CFG.standin) return;
    var f = document.getElementById('PBarNextFrameWrapper'), h = 0;   // the wrapper is the bar (68px); its iframe is full-height
    if (f) { var r = f.getBoundingClientRect(); if (r.height && r.top < window.innerHeight && r.bottom >= window.innerHeight - 4) h = Math.min(160, Math.round(window.innerHeight - r.top)); }
    document.documentElement.style.setProperty('--llp-pbar', h + 'px');
  }
  function show(source) {
    if (source === 'auto' && (dismissed || done || document.hidden || !document.hasFocus())) return;
    previewBar();
    removeTeaser();
    root.style.visibility = '';
    root.style.opacity = '';
    root.style.pointerEvents = '';
    root.style.position = '';
    root.style.inset = '';
    root.inert = false;
    root.classList.remove('llp--loading');
    root.classList.add('llp--in');
    root.hidden = false;
    isOpen = true;
    document.documentElement.classList.add('llp-lock');
    setStep(step, true);
    focusFirst();
    signal('shown', source);
  }
  function close(reason) {
    if (!isOpen) return;
    isOpen = false;
    root.inert = true;
    root.hidden = true;
    root.classList.remove('llp--in');
    document.documentElement.classList.remove('llp-lock');
    dismissed = true;
    sSet(S, 'teaser', 'off');
    removeTeaser();
    signal('closed', reason);
    if (step === 'success' || reason === 'redirect') {
      sSet(L, 'done', Date.now()); done = true;
      removeTeaser();
      restoreFocus(null);
      return;
    }
    sSet(L, 'hide', Date.now());
    restoreFocus(null);
  }
  function restoreFocus(el) {
    var t = el || (lastFocus && document.contains(lastFocus) ? lastFocus : null);
    if (t && t.focus) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
  }
  function focusables() {
    return $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', pop).filter(function (n) {
      return !n.disabled && n.getAttribute('aria-hidden') !== 'true' && (n.offsetWidth || n.offsetHeight || n.getClientRects().length) && getComputedStyle(n).visibility !== 'hidden';
    });
  }
  function focusFirst() {
    requestAnimationFrame(function () {
      if (!isOpen) return;
      var f = focusables().filter(function (n) { return host.contains(n); })[0] || $('[data-llp-close]', root);
      try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
    });
  }

  function setStep(s, quiet) {
    step = s;
    if (!root) return;
    root.setAttribute('data-step', s);
    $$('.llp-ern', root).forEach(function (e) { e.classList.toggle('is-on', (e.getAttribute('data-on') || '').split(' ').indexOf(s) > -1); });
    $$('[data-llp-face]', root).forEach(function (f) { f.setAttribute('aria-hidden', f.getAttribute('data-llp-face') === s ? 'false' : 'true'); });
    var idx = s === 'quiz' ? 0 : s === 'email' ? 1 : 2;
    $$('.llp-dots i', root).forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    if (s === 'success') { sSet(L, 'done', Date.now()); done = true; }
    if (standin && host) $$('.llp-st', host).forEach(function (n) { n.classList.toggle('is-on', n.getAttribute('data-s') === s); });
    if (pop) pop.scrollTop = 0;
    if (!quiet && isOpen) {
      // Klaviyo re-renders the step; put focus on its first control if focus fell out of the dialog
      setTimeout(function () { if (isOpen && !pop.contains(document.activeElement)) focusFirst(); }, 80);
    }
  }
  function advance(d) {
    var now = Date.now();
    if (d.type !== 'stepSubmit' && now - lastAdvance < 500) return;
    lastAdvance = now;
    var n = KLAVIYO.next[KLAVIYO.stepName(d)];
    if (n && typeof n === 'object') n = n[dev];
    if (!n) n = KLAVIYO.nextFromFields(d, dev);
    if (!n) { var o = KLAVIYO.order[dev]; n = o[Math.min(o.indexOf(step) + 1, o.length - 1)]; }
    if (n && n !== step) setStep(n);
  }

  /* restyle hooks on the embed's own text (words untouched) */
  var decoQueued = false;
  function decorate() {
    if (decoQueued || !host) return;
    decoQueued = true;
    requestAnimationFrame(function () {
      decoQueued = false;
      if (!host) return;
      $$('*', host).forEach(function (n) {
        if (n.classList.contains('llp-consent') || !KLAVIYO.consentRe.test(n.textContent || '')) return;
        var deeper = Array.prototype.some.call(n.children, function (c) { return KLAVIYO.consentRe.test(c.textContent || ''); });
        if (deeper) return;
        var b = n, len = (n.textContent || '').length;
        // climb to the consent block, but never to a box that also holds the step's controls
        while (b.parentElement && b.parentElement !== host && (b.parentElement.textContent || '').length <= len * 1.15 &&
          !b.parentElement.querySelector('button, input, select, textarea, [role="button"]')) b = b.parentElement;
        b.classList.add('llp-consent');
      });
      // 14px floor (design-system §13) for any Klaviyo text we can see, e.g. "Didn't get code? ... resend."
      $$('*', host).forEach(function (n) {
        if (n.classList.contains('llp-min14')) return;
        var own = Array.prototype.some.call(n.childNodes, function (c) { return c.nodeType === 3 && c.textContent.trim(); });
        if (own && parseFloat(getComputedStyle(n).fontSize) < 14) n.classList.add('llp-min14');
      });
      $$('button, a, [role="button"]', host).forEach(function (n) {
        var label = (n.textContent || '').trim();
        if (/^(KIDS|MYSELF \/ OTHER ADULTS|BOTH)$/i.test(label)) {
          n.classList.add('llp-embed-choice');
          n.setAttribute('data-llp-choice', /^KIDS$/i.test(label) ? 'kids' : /^BOTH$/i.test(label) ? 'both' : 'adults');
        }
        if (/^(CLAIM YOUR SAVINGS|SIGN UP FOR TEXTS|CLAIM DISCOUNT|START SAVING\s*→?)$/i.test(label)) n.classList.add('llp-embed-primary');
        if (/^CLAIM YOUR SAVINGS$/i.test(label)) n.classList.add('llp-embed-arrow');
        if (n.classList.contains('llp-decline') || !KLAVIYO.declineRe.test(n.textContent || '')) return;
        n.classList.add('llp-decline');
      });
      $$('p', host).forEach(function (n) {
        if (/^To (unlock|claim), share who you are shopping for/i.test((n.textContent || '').trim())) n.classList.add('llp-embed-question');
      });
    });
  }

  /* ---- Klaviyo events ---- */
  window.addEventListener(KLAVIYO.event, function (e) {
    var d = (e && e.detail) || {};
    if (String(d.formId || '') !== formId) return;
    var t = d.type;
    if (mode === 'popup') {                             // B2: only remember a finished form
      if (KLAVIYO.redirectTypes.indexOf(t) > -1 || (t === 'submit' && d.metaData && Object.keys(d.metaData).some(function (k) { return /phone|code/i.test(k); }))) { sSet(L, 'done', Date.now()); done = true; }
      if (KLAVIYO.closeTypes.indexOf(t) > -1 && !done) sSet(L, 'hide', Date.now());
      return;
    }
    if (!root) { if (KLAVIYO.readyTypes.indexOf(t) > -1) ready = true; return; }
    if (KLAVIYO.readyTypes.indexOf(t) > -1) markReady();
    else if (KLAVIYO.advanceTypes.indexOf(t) > -1) advance(d);
    else if (KLAVIYO.closeTypes.indexOf(t) > -1) close('klaviyo');
    else if (KLAVIYO.redirectTypes.indexOf(t) > -1) close('redirect');
  });

  /* ---- keyboard: Esc closes, Tab stays inside ---- */
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('esc'); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var a = f[0], z = f[f.length - 1], act = document.activeElement;
    if (!pop.contains(act)) { e.preventDefault(); a.focus(); }
    else if (e.shiftKey && act === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && act === z) { e.preventDefault(); a.focus(); }
  });

  /* ---- triggers (TIMING-ANALYSIS.md "Recommended triggers") ---- */
  function scrollPct() {
    var d = document.documentElement, max = Math.max(d.scrollHeight, document.body.scrollHeight) - window.innerHeight;
    return max <= 0 ? 100 : (window.scrollY || d.scrollTop) / max * 100;
  }
  /* Product pages: never open over a buy box. We wait until no add-to-cart form (in the page flow, not a fixed/sticky
     bar) is in the viewport, i.e. the shopper has scrolled past it. Applies on phone and desktop, to every trigger. */
  function buyBoxInView() {
    if (CFG.kind !== 'product') return false;
    return $$('form[action*="/cart/add"], [data-ll-buybox]').some(function (f) {
      if (root && root.contains(f)) return false;
      var r = f.getBoundingClientRect();
      if (!r.height || r.bottom <= 0 || r.top >= window.innerHeight) return false;
      for (var n = f; n && n !== document.body; n = n.parentElement) { var p = getComputedStyle(n).position; if (p === 'fixed' || p === 'sticky') return false; }
      return true;
    });
  }
  var fired = false;
  var SETTLE_MS = 700, lastScroll = 0, settleT = 0;
  function tryFire(reason) {
    if (fired || isOpen || opening || dismissed || done || document.hidden || !document.hasFocus()) return;
    if (Date.now() - t0 < delayMs) return;
    var timed = CFG.kind !== 'blog';
    var need = dev === 'phone' ? Number(CFG.scrollPhone) : Number(CFG.scrollDesktop);
    if (!(timed && (page2 || scrollPct() >= (isNaN(need) ? 50 : need)))) return;
    if (buyBoxInView()) return;
    // never open under a moving thumb: a lock mid-swipe feels like the page froze, so wait for the scroll to settle
    if (Date.now() - lastScroll < SETTLE_MS) { clearTimeout(settleT); settleT = setTimeout(function () { tryFire(reason); }, SETTLE_MS); return; }
    fired = true;
    sSet(S, 'shown', '1');
    KLAVIYO.isIdentified().then(function (known) { if (!known) openDialog('auto'); });
  }
  function arm() {
    setTimeout(function () { tryFire('time'); }, delayMs + 50);
    var q = false;
    window.addEventListener('scroll', function () {
      lastScroll = Date.now();
      if (q || fired) return; q = true;
      requestAnimationFrame(function () { q = false; tryFire('scroll'); });
    }, { passive: true });
    // No exit-intent trigger: moving to another screen/tab must not open the popup.
  }

  /* ---- start ---- */
  if (mode === 'embed') build();                        // watch the (hidden) embed from page load
  if (force === 'open') { setTimeout(function () { openDialog('force'); }, 300); return; }
  if (force === 'teaser') { setTimeout(showTeaser, 300); return; }
  if (done) return;
  /* stand-in: automated browsers (other sessions' screenshot QA on the draft) get no auto-open unless ?ll_popup=auto */
  if (standin && navigator.webdriver && llq !== 'auto') return;
  if (sGet(S, 'teaser') === 'on' || (teaserOnly && autoOk)) setTimeout(showTeaser, Math.max(0, delayMs - (Date.now() - t0)));
  if (autoOk && !teaserOnly) arm();
})();

